import moment from 'moment';
import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

import TwoDigitsCalendar from 'hb-react/shared/icons/dynamic/TwoDigitsCalendar';

const Calendar = ({
  timeStamp,
  timezone,
}: {
  timeStamp: string;
  timezone: string;
}) => {
  const momentObj = moment.tz(timeStamp, timezone);
  const month = momentObj.format('MMM').toUpperCase();
  const day = momentObj.format('DD');

  return (
    <Wrapper>
      <Month>{month}</Month>
      <StyledBox>
        <TwoDigitsCalendar width={40} height={40} day={Number(day)} />
      </StyledBox>
    </Wrapper>
  );
};

export default Calendar;

const Month = styled(Box).attrs({
  textAlign: 'center',
  mb: 2,
  fontSize: '16px',
  font: 'bold',
  fontWeight: 700,
  color: 'primary',
})``;

const Wrapper = styled(Box).attrs(() => ({
  flexDirection: 'column',
  mt: { _: 0, l: 2 },
  alignItems: 'center',
}))``;

const StyledBox = styled(Box).attrs(() => ({
  alignSelf: 'center',
  color: 'primary',
}))`
  box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 6px;
`;
